import { kebabCase } from 'lodash';

export const generateCSSBlock = (
	selector: string,
	rules: React.CSSProperties
): string => `
	${selector} {
		${Object.keys(rules)
			.map((propName) =>
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				typeof rules[propName] === 'undefined'
					? ''
					: [
							propName.startsWith('--') ? propName : kebabCase(propName),
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							rules[propName],
						].join(':') + ';'
			)
			.join('')}
	}
`;

export const generateCSSVariableBlock = (variables: {
	[name: string]: string | number;
}): string => `
	${Object.keys(variables)
		.map((name) => '--' + name + ':' + variables[name] + ';')
		.join('')}
`;
